import lodashPickBy from 'lodash/pickBy';

export const getPendingIssue = state => state.pendingIssue;
export const getPendingIssueForm = state => state.pendingIssueForm.$form;
export const getPendingIssueFormAttributes = state =>
  lodashPickBy(state.pendingIssueForm, (value, key) => key !== '$form');
